import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {ErrorCardModule} from "../../../../components/common/error-card/error-card.module";
import {LoadingModule} from "../../../../components/common/loading/loading.module";
import {ViewByAttributeComponent} from "./view-by-attribute.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        ErrorCardModule,
        LoadingModule,
    ],
    declarations: [
        ViewByAttributeComponent,
    ],
    exports: [ViewByAttributeComponent]
})
export class ViewByAttributeModule {
}